module.exports = __webpack_public_path__ + "img/cert18.41b1d700.png";